import { FC } from 'react'
import { buttonGroupButton, PerButtonGroup } from '../../ButtonGroup'

type PerInfoBoxButtonGroupElementProps = {
  buttons: buttonGroupButton[]
  defaultValue?: number
  disabled?: boolean
}

export const PerInfoBoxButtonGroupElement: FC<PerInfoBoxButtonGroupElementProps> = ({ buttons, defaultValue, disabled }) => {
  return <PerButtonGroup buttons={buttons} defaultValue={defaultValue} disabled={disabled} size="default" />
}
